import React from 'react';

import SvgContainer from '../SvgContainer';

const PointerDown = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100950)">
                <path d="M3.44702 10.9007C3.19237 10.6155 3.19237 10.1845 3.44702 9.89934C3.74568 9.56483 4.26892 9.56455 4.56795 9.89873L7.28571 12.936L7.28571 0.714286C7.28571 0.319796 7.60551 -6.43286e-08 8 -5.96244e-08C8.39449 -5.49202e-08 8.71429 0.319797 8.71429 0.714285L8.71429 12.936L11.4285 9.8961C11.729 9.55958 12.2557 9.5605 12.555 9.89808C12.8087 10.1843 12.808 10.6151 12.5533 10.9004L8.74594 15.1645C8.34834 15.6099 7.65166 15.6099 7.25406 15.1645L3.44702 10.9007Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100950">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default PointerDown;
